/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentReminderPreferenceResponse
 */
export interface AppointmentReminderPreferenceResponse {
    /**
     * UUID of the appointment reminder
     * @type {string}
     * @memberof AppointmentReminderPreferenceResponse
     */
    uuid?: string;
    /**
     * UUID of the institute
     * @type {string}
     * @memberof AppointmentReminderPreferenceResponse
     */
    instituteUuid?: string;
    /**
     * Is today reminder enabled
     * @type {boolean}
     * @memberof AppointmentReminderPreferenceResponse
     */
    isTodayReminderEnabled?: boolean;
    /**
     * Is the one day before reminder enabled
     * @type {boolean}
     * @memberof AppointmentReminderPreferenceResponse
     */
    isOneDayBeforeReminderEnabled?: boolean;
    /**
     * Is the three days before reminder enabled
     * @type {boolean}
     * @memberof AppointmentReminderPreferenceResponse
     */
    isThreeDaysBeforeReminderEnabled?: boolean;
    /**
     * Is the one week before reminder enabled
     * @type {boolean}
     * @memberof AppointmentReminderPreferenceResponse
     */
    isOneWeekReminderEnabled?: boolean;
}

/**
 * Check if a given object implements the AppointmentReminderPreferenceResponse interface.
 */
export function instanceOfAppointmentReminderPreferenceResponse(value: object): value is AppointmentReminderPreferenceResponse {
    return true;
}

export function AppointmentReminderPreferenceResponseFromJSON(json: any): AppointmentReminderPreferenceResponse {
    return AppointmentReminderPreferenceResponseFromJSONTyped(json, false);
}

export function AppointmentReminderPreferenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentReminderPreferenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'instituteUuid': json['instituteUuid'] == null ? undefined : json['instituteUuid'],
        'isTodayReminderEnabled': json['isTodayReminderEnabled'] == null ? undefined : json['isTodayReminderEnabled'],
        'isOneDayBeforeReminderEnabled': json['isOneDayBeforeReminderEnabled'] == null ? undefined : json['isOneDayBeforeReminderEnabled'],
        'isThreeDaysBeforeReminderEnabled': json['isThreeDaysBeforeReminderEnabled'] == null ? undefined : json['isThreeDaysBeforeReminderEnabled'],
        'isOneWeekReminderEnabled': json['isOneWeekReminderEnabled'] == null ? undefined : json['isOneWeekReminderEnabled'],
    };
}

export function AppointmentReminderPreferenceResponseToJSON(json: any): AppointmentReminderPreferenceResponse {
    return AppointmentReminderPreferenceResponseToJSONTyped(json, false);
}

export function AppointmentReminderPreferenceResponseToJSONTyped(value?: AppointmentReminderPreferenceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'instituteUuid': value['instituteUuid'],
        'isTodayReminderEnabled': value['isTodayReminderEnabled'],
        'isOneDayBeforeReminderEnabled': value['isOneDayBeforeReminderEnabled'],
        'isThreeDaysBeforeReminderEnabled': value['isThreeDaysBeforeReminderEnabled'],
        'isOneWeekReminderEnabled': value['isOneWeekReminderEnabled'],
    };
}

